"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _listField = _interopRequireDefault(require("./list-field"));

var _selectField = _interopRequireDefault(require("./select-field"));

var SelectListField =
/*#__PURE__*/
function (_ListField) {
  (0, _inherits2.default)(SelectListField, _ListField);

  function SelectListField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, SelectListField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(SelectListField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "_className", 'SelectListField');
    return _this;
  }

  (0, _createClass2.default)(SelectListField, [{
    key: "_create",
    value: function _create(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(SelectListField.prototype), "_create", this).call(this, props);
      this.set({
        schema: {
          component: 'Form',
          fields: [{
            name: 'fieldFactory',
            required: false
          }, {
            name: 'options',
            component: 'OptionsField',
            docLevel: 'basic'
          }, {
            name: 'blankString',
            component: 'TextField'
          }, {
            name: 'ensureInList',
            component: 'BooleanField'
          }]
        }
      });

      this._setDefaults(props, {
        autoCreateFields: true,
        canDeleteEmpty: false,
        startWithField: true,
        hideDeleteButton: true
      });
    }
  }, {
    key: "_onFieldCreated",
    value: function _onFieldCreated(field, onDelete) {
      var _this2 = this;

      field.on('value', function (value) {
        // Don't delete the last field
        if (!value && !_this2._isLastField(field)) {
          onDelete();
        } // Create last field if the last field is not blank and we are allowed to add more fields


        if (!_this2._isLastFieldBlank() && _this2.canAddMoreFields(value)) {
          _this2._createNewField();
        }

        _this2._calcValue();
      });
    }
  }, {
    key: "_newField",
    value: function _newField(name) {
      return new _selectField.default((0, _objectSpread2.default)({
        name: name,
        hideLabel: true,
        required: false
      }, this.get(['blankString', 'block', 'fullWidth', 'options', 'useDisplayValue', 'editable'])));
    }
  }, {
    key: "_createNewField",
    value: function _createNewField() {
      var field = this.createField();
      field.set({
        options: this.get('options')
      });
    }
  }, {
    key: "set",
    value: function set(props) {
      (0, _get2.default)((0, _getPrototypeOf3.default)(SelectListField.prototype), "set", this).call(this, props);

      this._setForAllFields(props, ['options', 'blankString', 'ensureInList']);
    }
  }, {
    key: "_shouldRemoveField",
    value: function _shouldRemoveField(field) {
      // Don't remove the last field as the user needs it to enter the next value
      return !this._isLastField(field);
    }
  }, {
    key: "clone",
    value: function clone() {
      var clonedField = (0, _get2.default)((0, _getPrototypeOf3.default)(SelectListField.prototype), "clone", this).call(this); // Clear the fields as the listeners now have the wrong references to the fields, etc...

      clonedField._clearFields(); // Create the default field


      clonedField._createNewField(); // Copy any existing value


      clonedField.setValue(this.getValue());
      return clonedField;
    }
  }]);
  return SelectListField;
}(_listField.default);

exports.default = SelectListField;